module.exports = __webpack_public_path__ + "static/media/401_AccessDenied.128d17b3.svg";